// src/RoleGate.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './Constant/Auth';

// Mirrors the role_id -> landing route switch in register/Login.js, so a
// user redirected away from a section they can't access lands somewhere
// that actually works for their own role instead of a dead end.
const DEFAULT_ROUTE_BY_ROLE = {
  1: '/admin/dashboard',
  2: '/school/dashboard',
  3: '/librarian/dashboard',
  4: '/dashboard',
  5: '/parent-dashboard'
};

// PrivateRoute only confirms "is someone logged in" — this additionally
// confirms "is this the section that role is allowed to see", so a
// logged-in Parent (role_id 5) can't render Librarian/Admin/School pages
// (or vice versa) just by typing the URL. Wrap the element for each route
// group with `<RoleGate allow={[...role ids]}>`.
const RoleGate = ({ allow, children }) => {
  const { user } = useAuth();
  const roleId = Number(user?.role_id);

  if (allow.includes(roleId)) {
    return children;
  }

  return <Navigate to={DEFAULT_ROUTE_BY_ROLE[roleId] || '/login'} replace />;
};

export default RoleGate;
